<template>
  <SAIDialogWrapper
    ref="dialog"
    @hide="$emit('hide')"
    :max-width="fullScreen ? null : '400px'"
    :maximized="fullScreen"
  >
    <div class="q-px-lg q-pb-sm" :style="{ 'min-width': minWidth }">
      <h4 class="text-weight-medium text-grey-10 q-mb-md">
        Pay to
      </h4>
      <div class="q-mb-md">
        <SAIFormLabel>Account Name</SAIFormLabel>
        <SAIInput
          :value="payload.accountName"
          placeholder="eg. John Smith"
          :error="$v.payload.accountName.$error"
          :minlength="$v.payload.accountName.$params.minLength.min"
          :maxlength="$v.payload.accountName.$params.maxLength.max"
          @input="payload = { ...payload, accountName: $event }"
        />
      </div>
      <div class="q-mb-md">
        <SAIFormLabel>BSB</SAIFormLabel>
        <SAIInput
          :value="payload.bsb"
          placeholder="xxxxxx"
          :error="$v.payload.bsb.$error"
          :minlength="$v.payload.bsb.$params.minLength.min"
          :maxlength="$v.payload.bsb.$params.maxLength.max"
          @input="updatePayloadWithNumbers('bsb', $event)"
        />
      </div>
      <div class="q-mb-md">
        <SAIFormLabel>Account Number</SAIFormLabel>
        <SAIInput
          :value="payload.accountNumber"
          placeholder="xxxxxx"
          :error="$v.payload.accountNumber.$error"
          :minlength="$v.payload.accountNumber.$params.minLength.min"
          :maxlength="$v.payload.accountNumber.$params.maxLength.max"
          @input="updatePayloadWithNumbers('accountNumber', $event)"
        />
      </div>
      <div class="row justify-end q-pt-sm">
        <SAIBtn
          color="grey-6"
          outline
          padding="12px 32px"
          :no-caps="true"
          @click="$emit('hide')"
        >
          <span class="text-weight-medium">Cancel</span>
        </SAIBtn>
        <SAIBtn
          class="q-ml-md"
          padding="12px 32px"
          :no-caps="true"
          @click="submit"
        >
          <p class="text-weight-medium">Submit</p>
        </SAIBtn>
      </div>
    </div>
  </SAIDialogWrapper>
</template>

<script>
import {
  SAIBtn,
  SAIDialogWrapper,
  SAIFormLabel,
  SAIInput
} from 'ecx.saigon.ui.common';
import validations from './validations';

export default {
  name: 'PayToDialog',
  props: {
    initialData: {
      type: Object,
      default: () => ({})
    },
    minWidth: {
      type: String,
      default: '400px'
    },
    fullScreen: Boolean
  },
  data() {
    return {
      payload: this.$Constants.INITIAL_PAY_TO_DATA
    };
  },
  validations,
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }

      this.$emit('ok', this.payload);
      this.hide();
    },
    updatePayloadWithNumbers(field, value) {
      this.payload = {
        ...this.payload,
        [field]: value.replace(/\D/g, '')
      };
    }
  },
  mounted() {
    this.payload = { ...this.initialData };
  },
  components: {
    SAIDialogWrapper,
    SAIBtn,
    SAIFormLabel,
    SAIInput
  }
};
</script>
